// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"dec4c112","7424":"72559762","8667":"34c7553d","9306":"9f733740"}[chunkId] + ".chunk.css";
};